/* The Print Doctor — product page: live quote, artwork upload (front/back), file check hooks,
   "design it for me" and "fix my file" fees. Dependency-free.
   Uploaded as assets/pd-product.js by theme_patch.py (edit the source here). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var picker = document.querySelector('variant-picker');
  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  function fmt(cents) { return money.format(cents / 100); }

  // ---------------- artwork block: elements (declared first; the quote reads the fee state) ----------------
  var art = document.querySelector('[data-pd-artwork]');
  var later, err, notes, brief, briefText, slots = [];
  if (art) {
    later = art.querySelector('[data-pd-later]'); err = art.querySelector('[data-pd-err]');
    notes = art.querySelector('input[name="properties[Notes]"]');
    brief = art.querySelector('[data-pd-brief]'); briefText = art.querySelector('[data-pd-brief-text]');
    slots = Array.prototype.map.call(art.querySelectorAll('[data-pd-slot]'), function (el) {
      return { el: el, side: el.dataset.pdSlot, input: el.querySelector('[data-pd-file]'), drop: el.querySelector('[data-pd-drop]'),
        name: el.querySelector('[data-pd-filename]'), label: el.querySelector('[data-pd-side-label]'), check: el.querySelector('[data-pd-check]'),
        prop: el.querySelector('[data-pd-check-prop]'), textUpload: el.querySelector('[data-pd-text-upload]'), textDesign: el.querySelector('[data-pd-text-design]'),
        state: '', pages: 1 };
    });
  }
  function fileOf(s) { return s.input.files && s.input.files[0]; }
  function mode() {
    if (!art) return 'upload';
    var r = art.querySelector('input[name="properties[Artwork]"]:checked');
    if (!r) return 'upload';
    if (r.hasAttribute('data-pd-design')) return 'design';
    if (/email/i.test(r.value)) return 'later';
    return 'upload';
  }
  function designFee() { return art && art.dataset.pdDesignVariant ? parseInt(art.dataset.pdDesignPrice, 10) || 0 : 0; }
  function fixFee() { return art && art.dataset.pdFixVariant ? parseInt(art.dataset.pdFixPrice, 10) || 0 : 0; }
  function fixWanted() { return slots.some(function (s) { var c = s.check && s.check.querySelector('[data-pd-fix]'); return c && c.checked && !s.el.hidden; }); }

  // ---------------- size you can see: each Size button draws its rectangle to true relative scale ----
  (function () {
    var parse = window.pdPreflight && window.pdPreflight.parseSize;
    if (!parse) return;
    document.querySelectorAll('fieldset[data-pd-opt="size"],fieldset[data-pd-opt="size-sides"]').forEach(function (f) {
      var labels = f.querySelectorAll('.variant-option__button-label'), dims = [], maxW = 0, maxH = 0, n = 0;
      labels.forEach(function (l) {
        var t = l.querySelector('.variant-option__button-label__text');
        var sz = parse((t ? t.textContent : l.textContent).split(' · ')[0]);
        if (sz && sz.max) sz = null;
        dims.push(sz);
        if (sz) { n++; maxW = Math.max(maxW, sz.w); maxH = Math.max(maxH, sz.h); }
      });
      if (n < 2 || !maxW || !maxH) { f.removeAttribute('data-pd-shapes'); return; }
      // a 5x range (18" to 90") drawn at true scale leaves the small ones as specks; a gentle
      // power curve keeps the order and the proportions readable inside a button
      var sc = function (v) { return Math.pow(v, 0.62); };
      var k = Math.min(64 / sc(maxW), 44 / sc(maxH));
      f.setAttribute('data-pd-shapes', '');
      labels.forEach(function (l, i) {
        var sz = dims[i]; if (!sz) return;
        var sh = document.createElement('i'); sh.className = 'pd-shape'; sh.setAttribute('aria-hidden', 'true');
        sh.style.width = Math.max(10, sc(sz.w) * k).toFixed(1) + 'px'; sh.style.height = Math.max(8, sc(sz.h) * k).toFixed(1) + 'px';
        var t = l.querySelector('.variant-option__button-label__text');
        (t || l).insertAdjacentElement(t ? 'beforebegin' : 'afterbegin', sh);
      });
    });
    // printing / sides options: ink marks (CMYK dots for full colour, one dot per spot colour) and page glyphs
    document.querySelectorAll('fieldset[data-pd-opt="printing"],fieldset[data-pd-opt="sides"]').forEach(function (f) {
      f.querySelectorAll('.variant-option__button-label').forEach(function (l) {
        var t = l.querySelector('.variant-option__button-label__text'); if (!t) return;
        var txt = t.textContent, c = /full[\s-]*colou?r|4\/[04]|cmyk/i.test(txt) ? 4 : (/(\d)\s*colou?r/i.test(txt) ? +RegExp.$1 : 0);
        var sd = /(\d)\s*side/i.test(txt) ? +RegExp.$1 : (/double|both/i.test(txt) ? 2 : 0);
        if (!c && !sd) return;
        var m = document.createElement('i'); m.className = 'pd-marks'; m.setAttribute('aria-hidden', 'true');
        var html = '';
        if (c === 4) html += '<b class="pd-marks__c"></b><b class="pd-marks__m"></b><b class="pd-marks__y"></b><b class="pd-marks__k"></b>';
        else for (var i = 0; i < c; i++) html += '<b class="pd-marks__k"></b>';
        if (sd) { html += '<u class="pd-marks__page"></u>'; if (sd === 2) html += '<u class="pd-marks__page pd-marks__page--back"></u>'; }
        m.innerHTML = html;
        t.insertAdjacentElement('beforebegin', m);
      });
    });
  })();

  // ---------------- live quote (signed-in customers only; the data block is not rendered otherwise) ----
  var quote = document.querySelector('[data-pd-quote]');
  var data = null;
  if (quote) { try { data = JSON.parse(quote.querySelector('[data-pd-variants]').textContent); } catch (e) { data = null; } }

  function selected() {
    var sel = {};
    // options with a single value have no input in Horizon's picker; the theme lists them on the artwork block
    if (art && art.dataset.pdFixed) art.dataset.pdFixed.split('|').forEach(function (kv) {
      var i = kv.indexOf('='); if (i > 0) sel[kv.slice(0, i)] = kv.slice(i + 1);
    });
    if (!picker) return sel;
    picker.querySelectorAll('input[type=radio]:checked').forEach(function (i) { if (i.dataset.optionName) sel[i.dataset.optionName] = i.value; });
    picker.querySelectorAll('select').forEach(function (s) {
      var o = s.options[s.selectedIndex]; if (o && o.dataset.optionName) sel[o.dataset.optionName] = o.value;
    });
    return sel;
  }
  function find(sel) {
    var names = data.options;
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i], ok = true;
      for (var j = 0; j < names.length; j++) { var w = sel[names[j]]; if (w !== undefined && w !== v.o[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  var shown = 0, raf = 0;
  function tick(el, to) {
    if (reduce || !shown) { el.textContent = fmt(to); shown = to; return; }
    cancelAnimationFrame(raf);
    var from = shown, t0 = performance.now(), dur = 520;
    el.classList.add('is-ticking');
    (function step(t) {
      var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(Math.round(from + (to - from) * k));
      if (k < 1) raf = requestAnimationFrame(step); else { shown = to; el.classList.remove('is-ticking'); }
    })(t0);
  }
  function update() {
    if (!quote || !data) return;
    var v = find(selected());
    var total = quote.querySelector('[data-pd-total]'), meta = quote.querySelector('[data-pd-meta]');
    quote.classList.toggle('is-unavailable', !v || !v.a);
    if (!v) { meta.textContent = 'That combination is not available. Pick another size or quantity.'; return; }
    var m = mode(), fee = m === 'design' ? designFee() : (m === 'upload' && fixWanted() ? fixFee() : 0);
    tick(total, v.p + fee);
    var qi = parseInt(quote.dataset.qi, 10), unit = quote.dataset.unit || 'ea', line = '';
    if (qi >= 0) {
      var n = parseInt(String(v.o[qi]).replace(/,/g, ''), 10) || 1;
      if (n > 1) {
        line = unit === 'ea'
          ? fmt(v.p / n) + ' each · ' + n.toLocaleString() + ' pieces'
          : fmt(v.p / n) + ' per ' + unit + ' · ' + n.toLocaleString() + ' ' + unit + 's';
      }
    }
    if (fee) line += (line ? ' · ' : '') + 'includes ' + fmt(fee) + (m === 'design' ? ' design' : ' file fix');
    if (!line && !v.a) line = 'Not available right now.';
    meta.textContent = line;
  }
  // the quantity tiers as a curve: per-piece price falling with quantity, the chosen tier marked
  (function () {
    var f = document.querySelector('fieldset[data-pd-qty]'); if (!f) return;
    var labels = Array.prototype.slice.call(f.querySelectorAll('.variant-option__button-label'));
    var pts = labels.map(function (l) { var b = l.querySelector('.pd-tier b'); var q = (l.querySelector('.variant-option__button-label__text') || l).textContent.replace(/,/g, ''); return b ? { q: parseInt(q, 10) || 0, p: parseFloat(b.textContent.replace(/[^0-9.]/g, '')) || 0, l: l } : null; });
    if (pts.some(function (p) { return !p; }) || pts.length < 3) return;
    var W = 320, H = 56, pad = 8, max = Math.max.apply(null, pts.map(function (p) { return p.p; })), min = Math.min.apply(null, pts.map(function (p) { return p.p; }));
    var curve = document.createElement('div'); curve.className = 'pd-curve'; curve.setAttribute('aria-hidden', 'true');
    function xy(i, p) { var x = pad + (W - 2 * pad) * (pts.length === 1 ? 0 : i / (pts.length - 1)); var y = pad + (H - 2 * pad) * (max === min ? .5 : (p.p - min) / (max - min)); return [x, H - y + 0]; }
    function draw() {
      var sel = -1; pts.forEach(function (p, i) { var inp = p.l.querySelector('input'); if (inp && inp.checked) sel = i; });
      var d = pts.map(function (p, i) { var c = xy(i, p); return (i ? 'L' : 'M') + c[0].toFixed(1) + ' ' + c[1].toFixed(1); }).join(' ');
      var dots = pts.map(function (p, i) { var c = xy(i, p); return '<circle cx="' + c[0].toFixed(1) + '" cy="' + c[1].toFixed(1) + '" r="' + (i === sel ? 5 : 2.5) + '" class="' + (i === sel ? 'is-sel' : '') + '"/>'; }).join('');
      var lab = sel >= 0 ? (function () { var c = xy(sel, pts[sel]); return '<text x="' + Math.min(W - 60, Math.max(4, c[0] - 24)).toFixed(1) + '" y="' + (c[1] < 22 ? c[1] + 18 : c[1] - 10).toFixed(1) + '">' + fmt(pts[sel].p * 100) + ' each</text>'; })() : '';
      curve.innerHTML = '<svg viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none"><path d="' + d + '"/>' + dots + lab + '</svg><span class="pd-curve__cap">per piece, ' + pts[0].q.toLocaleString() + ' to ' + pts[pts.length - 1].q.toLocaleString() + ' pieces</span>';
    }
    draw();
    var leg = f.querySelector('legend'); (leg || f).insertAdjacentElement(leg ? 'afterend' : 'afterbegin', curve);
    document.addEventListener('change', function (e) { if (f.contains(e.target)) draw(); });
  })();

  // a quantity the owner hid from the store has no chip; if Shopify's default variant was one of
  // those, no chip is checked on load, so move to the first quantity that is offered
  (function () {
    var f = document.querySelector('fieldset[data-pd-qty]'); if (!f) return;
    if (f.querySelector('input[type=radio]:checked')) return;
    var first = f.querySelector('input[type=radio]:not([aria-disabled="true"])');
    if (first) first.click();
  })();

  if (quote && data) {
    update();
    document.addEventListener('change', function (e) { if (picker && picker.contains(e.target)) update(); });
    window.addEventListener('popstate', update);
  }

  // ---------------- artwork behaviour ----------------
  if (!art) return;
  var MAX = 20 * 1024 * 1024;
  function show(msg) { err.textContent = msg; err.hidden = false; }

  var TWO = /\b2[\s-]*side|\btwo[\s-]*side|double[\s-]*side|\b4\/4\b/i;
  function selectedSize() {
    var sel = selected(), out = { size: '', sides: art && art.dataset.pdTwoSided ? 2 : 1 };
    Object.keys(sel).forEach(function (k) {
      var v = String(sel[k]);
      if (/size/i.test(k) && !out.size) out.size = v.split(' · ')[0];
      if (TWO.test(v)) out.sides = 2;
    });
    // products with no size option at all: a fixed artwork size from the custom.artwork_size metafield
    if (!out.size && art && art.dataset.pdSize) out.size = art.dataset.pdSize;
    return out;
  }
  function twoSided() { return selectedSize().sides === 2; }
  function frontHasBoth() { var f = slots[0]; return !!(f && fileOf(f) && f.pages >= 2); }

  function runCheck(s) {
    if (!s.check || !window.pdPreflight) return;
    var f = fileOf(s);
    if (!f || mode() !== 'upload' || s.el.hidden) { window.pdPreflight.clear(s.check); s.state = ''; if (s.prop) s.prop.disabled = true; update(); return; }
    var ctx = selectedSize(); ctx.side = s.side; ctx.fix = fixFee(); ctx.design = designFee();
    s.state = 'busy';
    window.pdPreflight.run(f, ctx, s.check).then(function (r) {
      s.state = r.state; s.pages = r.pages;
      if (s.prop) { s.prop.value = r.summary; s.prop.disabled = false; }
      if (s.side === 'front') syncSlots();
      update();
    });
  }
  function runChecks() { slots.forEach(runCheck); }

  function syncSlots() {
    var m = mode(), two = twoSided();
    slots.forEach(function (s) {
      var isBack = s.side === 'back';
      var visible = m !== 'later' && !(isBack && (m === 'design' || !two));
      if (s.el.hidden !== !visible) { s.el.hidden = !visible; if (!visible && isBack) { s.input.value = ''; showFile(s); } }
      if (s.label) s.label.hidden = !(m === 'upload' && two);
      if (s.textUpload) s.textUpload.hidden = m === 'design';
      if (s.textDesign) s.textDesign.hidden = m !== 'design';
    });
  }
  function sync() {
    var m = mode();
    later.hidden = m !== 'later';
    if (brief) brief.hidden = m !== 'design';
    err.hidden = true;
    syncSlots();
    runChecks();
    update();
  }
  function showFile(s) {
    var f = fileOf(s);
    if (!f) { s.name.hidden = true; s.drop.classList.remove('has-file'); s.pages = 1; runCheck(s); return; }
    if (f.size > MAX) {
      s.input.value = ''; s.name.hidden = true; s.drop.classList.remove('has-file'); s.pages = 1; runCheck(s);
      show('That file is ' + (f.size / 1048576).toFixed(0) + ' MB and the limit here is 20 MB. Choose "Send it later" and email it after ordering.');
      return;
    }
    s.name.textContent = f.name + ' · ' + (f.size / 1048576).toFixed(1) + ' MB';
    s.name.hidden = false; s.drop.classList.add('has-file'); err.hidden = true;
    runCheck(s);
  }
  slots.forEach(function (s) {
    s.input.addEventListener('change', function () { showFile(s); });
    ['dragenter', 'dragover'].forEach(function (n) { s.drop.addEventListener(n, function (e) { e.preventDefault(); s.drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (n) { s.drop.addEventListener(n, function (e) { e.preventDefault(); s.drop.classList.remove('is-over'); }); });
    s.drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) { try { s.input.files = e.dataTransfer.files; } catch (x) {} showFile(s); }
    });
    // "print as is" and "fix it" are alternatives; the fee shows in the quote straight away
    s.check.addEventListener('change', function (e) {
      if (e.target.matches('[data-pd-ack]') && e.target.checked) { var fx = s.check.querySelector('[data-pd-fix]'); if (fx) fx.checked = false; }
      if (e.target.matches('[data-pd-fix]') && e.target.checked) { var ak = s.check.querySelector('[data-pd-ack]'); if (ak) ak.checked = false; }
      err.hidden = true; update();
    });
  });
  art.addEventListener('change', function (e) { if (e.target.name === 'properties[Artwork]') sync(); });
  // a new size or sides changes the verdicts and which slots show; re-check from the cached analysis
  document.addEventListener('change', function (e) { if (picker && picker.contains(e.target)) { syncSlots(); runChecks(); } });
  sync();

  var form = art.closest('form');
  if (!form) return;

  // fees go in the cart as their own lines, tagged with what they are for, before the item itself
  function addFee(variantId, label) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    var sel = selected(), opts = Object.keys(sel).map(function (k) { return sel[k]; }).join(' / ');
    fd.append('properties[For]', (art.dataset.pdProductTitle || document.title) + (opts ? ' — ' + opts : ''));
    if (label) fd.append('properties[Service]', label);
    var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
    return fetch(url, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('fee'); return r.json(); });
  }
  function feesNeeded() {
    var m = mode(), out = [];
    if (m === 'design' && art.dataset.pdDesignVariant) out.push([art.dataset.pdDesignVariant, 'Design it for me']);
    if (m === 'upload' && fixWanted() && art.dataset.pdFixVariant) out.push([art.dataset.pdFixVariant, 'Fix my file']);
    return out;
  }

  var feesDone = false, busy = false;
  // Runs before the theme's own submit handler (capture phase on the form itself).
  form.addEventListener('submit', function (e) {
    err.hidden = true;
    var m = mode();
    var front = slots[0], back = slots[1];
    var frontFile = front && fileOf(front), backFile = back && !back.el.hidden && fileOf(back);
    function block(msg, focusEl) { e.preventDefault(); e.stopImmediatePropagation(); show(msg); if (focusEl) focusEl.focus(); }

    if (m === 'upload') {
      if (!frontFile) {
        block('Add your print file, or choose "Send it later".', front.input);
        front.drop.classList.add('is-shake'); setTimeout(function () { front.drop.classList.remove('is-shake'); }, 600);
        return;
      }
      if (twoSided() && !backFile && !frontHasBoth()) {
        block('This is printed on both sides. Add the back file, or send one PDF with the back as page 2.', back ? back.input : front.input);
        if (back) { back.drop.classList.add('is-shake'); setTimeout(function () { back.drop.classList.remove('is-shake'); }, 600); }
        return;
      }
      var stop = false;
      slots.forEach(function (s) {
        if (stop || s.el.hidden || !fileOf(s)) return;
        if (s.state === 'busy') { block('Still reading your ' + (twoSided() ? s.side + ' ' : '') + 'file. One moment, then try again.'); stop = true; return; }
        var ack = s.check.querySelector('[data-pd-ack]'), fix = s.check.querySelector('[data-pd-fix]');
        if (s.state === 'bad' && !(ack && ack.checked) && !(fix && fix.checked)) {
          block('The file check found a problem' + (twoSided() ? ' on the ' + s.side : '') + '. Fix the file, tick "print it as it is"' + (fix ? ', have us fix it' : '') + ', or choose "Design it for me".', ack || fix);
          stop = true; return;
        }
        if (s.prop && !s.prop.disabled) {
          var base = s.prop.value.replace(/ \| (fix requested|accepted as-is)$/, '');
          if (fix && fix.checked) s.prop.value = (base + ' | fix requested').slice(0, 250);
          else if (ack && ack.checked) s.prop.value = (base + ' | accepted as-is').slice(0, 250);
          else s.prop.value = base;
        }
      });
      if (stop) return;
    }
    if (m === 'design' && briefText && !briefText.value.trim()) {
      block('Tell us what the design should say and look like.', briefText);
      return;
    }
    var fees = feesNeeded();
    if (fees.length && !feesDone) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (busy) return;
      busy = true; form.classList.add('is-busy');
      fees.reduce(function (p, f) { return p.then(function () { return addFee(f[0], f[1]); }); }, Promise.resolve()).then(function () {
        feesDone = true; busy = false; form.classList.remove('is-busy');
        form.requestSubmit();
        setTimeout(function () { feesDone = false; }, 1500);
      }).catch(function () {
        busy = false; form.classList.remove('is-busy');
        show('The service fee could not be added just now. Try again, or choose "Send it later" and email us.');
      });
      return;
    }
    // empty fields must not become empty line-item properties: disable them while the theme builds FormData
    var off = [];
    slots.forEach(function (s) {
      if (!fileOf(s) || s.el.hidden) { s.input.disabled = true; off.push(s.input); if (s.prop && !s.prop.disabled) { s.prop.disabled = true; off.push(s.prop); } }
      else if (m !== 'upload' && s.prop && !s.prop.disabled) { s.prop.disabled = true; off.push(s.prop); }
    });
    if (notes && !notes.value.trim()) { notes.disabled = true; off.push(notes); }
    if (briefText && (m !== 'design' || !briefText.value.trim())) { briefText.disabled = true; off.push(briefText); }
    setTimeout(function () { off.forEach(function (i) { i.disabled = false; }); }, 0);
  }, true);
})();
